<template>
  <div
    :id="props.id || 'card-' + random_id"
    :data-testid="
      props.dataTestid
        ? props.dataTestid + '-card-container'
        : '-card-container'
    "
    :class="
      twMerge(
        'ts-content shadow-md border border-natural-light-grey rounded-xl overflow-hidden bg-idle-white lg:flex items-start',
        (props.noShadow || props.cardStyles.noShadow) && 'shadow-none',
        (props.noBorder || props.cardStyles.noBorder) && 'border-0',
        props.cardStyles.reverseDirection && 'lg:flex-row-reverse',
        props.cardStyles.heightFull && 'h-full',
        props.cardStyles.align === 'center' && 'items-center',
        props.cardStyles.align === 'end' && 'items-end',
        props.appendClass
      )
    "
    :style="card_styles"
  >
    <TsImage
        v-if="props.image" 
        :src="props.image"
        :alt="props.alt ||'imagecard'"
        class="shrink w-full h-auto"
        width="616"
        height="316"
        :style="image_styles"
        loading="lazy"
    />
    <div :class="twMerge('grow h-full p-4', props.cardStyles.noPadding && 'p-0')">
      <slot>
        <Blocks
            :parent="props.builderBlock?.id"
            :path="`component.options.blockContent`"
            :blocks="props.blockContent"
        />
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref, onMounted} from "vue";
import {useRandomUUID} from "~/composables/useRandomUUID";
import {twMerge} from "tailwind-merge";
import {Blocks} from '@builder.io/sdk-vue';

type Props = {
  id?: string;
  alt: string;
  builderBlock?: object;
  blockContent?: any[];
  appendClass?: string;
  noShadow?: boolean;
  noBorder?: boolean;
  dataTestid?: string;
  image?: object;
  cardStyles?: object;
  imageStyles?: object;
  contentStyles?: object;
};

const props = withDefaults(defineProps<Props>(), {});

const card_styles = computed(() => ({
  ...(props.cardStyles && props.cardStyles.backgroundColor && {backgroundColor: props.cardStyles.backgroundColor}),
  ...(props.cardStyles && (props.cardStyles.borderRadius || props.cardStyles.borderRadius === 0) && {borderRadius: `${props.cardStyles.borderRadius}px`}),
}))

const image_styles = computed(() => ({
  ...(props.imageStyles && props.imageStyles.borderRadius && (props.imageStyles.borderRadius.topLeft || props.imageStyles.borderRadius.topLeft === 0) && {borderTopLeftRadius: `${props.imageStyles.borderRadius.topLeft}px`}),
  ...(props.imageStyles && props.imageStyles.borderRadius && (props.imageStyles.borderRadius.topRight || props.imageStyles.borderRadius.topRight === 0) && {borderTopRightRadius: `${props.imageStyles.borderRadius.topRight}px`}),
  ...(props.imageStyles && props.imageStyles.borderRadius && (props.imageStyles.borderRadius.bottomRight || props.imageStyles.borderRadius.bottomRight === 0) && {borderBottomRightRadius: `${props.imageStyles.borderRadius.bottomRight}px`}),
  ...(props.imageStyles && props.imageStyles.borderRadius && (props.imageStyles.borderRadius.bottomLeft || props.imageStyles.borderRadius.bottomLeft === 0) && {borderBottomLeftRadius: `${props.imageStyles.borderRadius.bottomLeft}px`})
}))

const random_id = ref<string>("");
onMounted(() => {
  random_id.value = useRandomUUID();
});
</script>
